import React,{useState} from "react";
import { Card } from "react-bootstrap";
import styles from "./NoticeCard.module.css";
import { FaRegEdit } from "react-icons/fa";
import CustomSkeleton from "../CustomSkeleton";
import DeleteIcon from "../Inputs/DeleteIcon";
import DeleteModel from './../modals/DeleteModel';

function NoticeCard({loading, notice, onClick, onDelete}) {
  const { title, note, date, created_at, created_by, author } = notice;
  // const dateTime = new Date(created_at||date).toLocaleString();
  const dateTime = new Date(created_at||date).toLocaleDateString();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  
  const handleOpenDeleteModal = () => {
    setShowDeleteModal(true);
  };
  
  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

    const handleDeleteConfirmation = () => {
    onDelete(notice.id); 
    handleCloseDeleteModal(); 
  };

  if (loading) {
    return (
      <Card className={`${styles.card} rounded-4`}>
        <Card.Body>
          <CustomSkeleton height="20px" width="100%" />
        </Card.Body>
      </Card>
    );
  }
  return (
    <Card className={`${styles.card} rounded-4 w-100`}>
      <Card.Body>
        <p className="p4 fw-bold text-truncate">{title}</p>
        <p className={`${styles.note} p5 fw-regular`}>{note}</p>
        <div className="d-flex justify-content-between align-items-center">
            <p className="p6 fw-medium m-0">{dateTime}</p>
            <p className="p6 fw-medium m-0 text-truncate text-capitalize">{"("}{created_by.first_name||author}{")"}</p>
            <div className="d-flex gap-2">
            <EditIcon onClick={onClick}/>
            <DeleteIcon size={13} onDelete={handleOpenDeleteModal}/>
            </div>
        </div>
        
      </Card.Body>

      {/* Delete confirmation modal */}
      <DeleteModel
        open={showDeleteModal}
        closeAlert={handleCloseDeleteModal}
        onClick={handleDeleteConfirmation}
        type="note"
      />
    </Card>
  );
}

export default NoticeCard;


const EditIcon = ({onClick}) => {
    return (
        <div className={`${styles.editIcon} d-inline-flex justify-content-center align-items-center p-2 rounded-5`}>
          <FaRegEdit onClick={onClick} color="#0BA7FF"/>
        </div>
    )
}